export const formatUTCDateShort = (value: Date) : string => {
  if (value === null) {
    return '-';
  }

  const day = value.getDate();
  const weekDay = value.toLocaleString('en-GB', { weekday: 'short' });
  const month = value.toLocaleString('en-GB', { month: 'short' });
  const year = value.getFullYear();

  return `${weekDay} ${day} ${month} ${year}`;
};
